module.exports = __webpack_public_path__ + "static/img/19.8af91d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/csfish/19.png
// module id = LmGJ
// module chunks = 0